import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  CompanyGovernmentAllocationData,
  CompanyGovernmentAllocationResponse,
} from '@/features/privateCompanies/types/companyGovernmentAllocation.type'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export const useCompanyGovernmentAllocation: (
  id: string,
) => UseQueryResult<CompanyGovernmentAllocationData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<CompanyGovernmentAllocationResponse, unknown, CompanyGovernmentAllocationData>({
    queryKey: ['companyGovernmentAllocation', id],
    queryFn: () => privateAxios.get(`/billing/government_allocations/${id}`),
    select: (data) => {
      return data?.data?.data
    },
  })
}
